import { take } from "redux-saga/effects";
import { START_CONVERSATION } from "../constants";

export function* startConv(socket) {
  while (true) {
    yield take(START_CONVERSATION);
    socket.emit("conversation-started");
  }
}
